import { Change, EntityName, RequestPayload } from '../types/PayloadTypes';

const FIELD_NAMES = {
	RUN_ID: 'run_id',
	CUSTOM_FIELDS: 'custom_fields',
	ENVIRONMENTS: 'environment',
	FLOWS: 'flow'
} as const;

export const buildBasePayload = (runId: string, entityName: EntityName = 'all'): RequestPayload => {
	return {
		scope: {
			conditions: [{ field: FIELD_NAMES.RUN_ID, value: runId }],
			entityName
		},
		changes: []
	};
};

export const addChanges = (payload: RequestPayload, changes: Change[]): RequestPayload => {
	return {
		...payload,
		changes: [...payload.changes, ...changes]
	};
};

export const createCustomFieldAddChange = (key: string, value: string): Change => {
	return {
		fieldName: FIELD_NAMES.CUSTOM_FIELDS,
		value: [key, value],
		operation: 'add'
	};
};

export const createCustomFieldRemoveChange = (key: string, value: string): Change => {
	return {
		fieldName: FIELD_NAMES.CUSTOM_FIELDS,
		value: [key, value],
		operation: 'remove'
	};
};

// Use 'set' operation with empty string to remove the value
export const ENVIRONMENT_REMOVE_CHANGE: Change = {
	fieldName: FIELD_NAMES.ENVIRONMENTS,
	value: '',
	operation: 'set'
};

// Use 'set' operation with empty string to remove the value
export const FLOW_REMOVE_CHANGE: Change = {
	fieldName: FIELD_NAMES.FLOWS,
	value: '',
	operation: 'set'
};
